module.exports = __webpack_public_path__ + "img/icons-sprite.6592f043.svg";